import config from 'config';
import CryptoJS from 'crypto-js';

export const decryptSignUpFormValues = (encryptedValues: string) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedValues, config.signUpKey).toString(
    CryptoJS.enc.Utf8,
  );
  return JSON.parse(decrypted);
};
